<template>
  <div id="app" @click="isTimeOut">
    <el-container class="height-z100" direction="vertical">
      <el-header  v-if="header_show">
        <div class="data-header">
          <div style="width: 390px;float: left;" class="margin-l-20">
            <div style="height: 40px; padding-top: 10px;" class="text-left">
              <!-- 【★ 兼容写法：替换 ?. 为 && 判空】 -->
              <p style="margin-top: 2px; font-family: 庞门正道标题体;font-size: 28px"
                 v-if="userInfo && !countyUserList.includes(userInfo && userInfo.username)">
                九江市电子商务大数据系统</p>
              <p
                style="margin-top: 2px; font-family: 庞门正道标题体;font-size: 28px ;width: 600px"
                v-if="userInfo && countyUserList.includes(userInfo && userInfo.username)"
              >
                九江市县域电子商务大数据系统(试运行)
              </p>
            </div>
          </div>
          <!-- 【★ 兼容写法：简化判空条件】 -->
          <div style="text-align: left; padding-top: 16px;font-family: Microsoft YaHei;" v-if="userInfo" class="float-right font-16">
            欢迎你，{{ (userInfo && userInfo.username) || '未登录' }}
            /<span @click="userOut" class="margin-r-20 cursor-pointer font-14">退出登录</span>
          </div>
        </div>
      </el-header>
      <el-container class="content" style="overflow: hidden" >
        <el-aside width="230px" v-if="header_show">
          <el-menu :default-active="active_path" v-if="header_show" class="el-menu-vertical-demo" background-color="#3865A5"
                   text-color="#fff" router=""
                   active-text-color="#fff" mode="vertical"
                   style="width: 230px;min-height: 100%;text-align: left;float: left;clear: both"
                   :default-openeds="open_list">
            <el-submenu index="1" v-if="isShow">
              <template slot="title">
                <i class="el-icon-place"></i>
                <span class="font-16">电商全景</span>
              </template>
              <el-menu-item index="/index" >九江市全景分析</el-menu-item>
              <!-- 【★ 兼容写法：替换 ?. 为 && 判空】 -->
              <el-menu-item index="/JXData" v-if="userInfo && userInfo.username !=='jiujiangnongye'">江西省电商看板</el-menu-item>
              <el-menu-item index="/localArea">九江市整体分析</el-menu-item>
              <el-menu-item index="/industryAnalysis">实物类行业分析</el-menu-item>
              <el-menu-item index="/nonPhysical">非实物类行业分析</el-menu-item>
              <el-menu-item index="/goodsType">商品类型分析</el-menu-item>
              <el-menu-item index="/transactionMode">交易模式分析</el-menu-item>
              <el-menu-item index="/tradingPlatform">电商平台分析</el-menu-item>
              <el-menu-item index="/rankingList">排行榜</el-menu-item>
            </el-submenu>
            <el-submenu index="2" v-if="isShow">
              <template slot="title">
                <i class="el-icon-aim"></i>
                <span class="font-16">农业电商</span>
              </template>
              <el-menu-item index="/countrysideBusiness">农村电商</el-menu-item>
              <el-menu-item index="/agricultureProducts">农产品网络零售</el-menu-item>
              <el-menu-item index="/agriculturalMeans">农资网络零售</el-menu-item>
            </el-submenu>
            <el-submenu index="3" v-if="isShow">
              <template slot="title">
                <i class="el-icon-mobile-phone"></i>
                <span class="font-16">在线电商</span>
              </template>
              <el-menu-item index="/restaurant">掌上餐饮</el-menu-item>
              <el-menu-item index="/tour">掌上旅游</el-menu-item>
            </el-submenu>
            <el-submenu index="4" v-if="isShow">
              <template slot="title">
                <i class="el-icon-cherry"></i>
                <span class="font-16">特色产品</span>
              </template>
              <el-menu-item index="/ganPin">产品概览</el-menu-item>
              <el-menu-item index="/ganPinAnalysis">产品详情</el-menu-item>
            </el-submenu>
            <el-submenu index="6" v-if="isShow">
              <template slot="title">
                <i class="el-icon-goods"></i>
                <span class="font-16">特色电商</span>
              </template>
              <el-menu-item index="/community">社区电商</el-menu-item>
              <el-menu-item index="/selfBuildPlatform">自建平台</el-menu-item>
            </el-submenu>
            <!-- 【★ 兼容写法：替换 ?. 为 && 判空】 -->
            <el-submenu index="7" v-if="userInfo && userInfo.username !=='jiujiangnongye'" v-show="isShow">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span class="font-16">电商企业库</span>
              </template>
              <el-menu-item index="/companyIndex">企业一户式查询</el-menu-item>
              <el-menu-item index="/companyFocus">重点企业分析</el-menu-item>
            </el-submenu>
            <el-submenu index="8" v-show ="!isShow">
              <template slot="title">
                <i class="el-icon-goods"></i>
                <span class="font-16">全景分析</span>
              </template>
              <!-- 【★ 兼容写法：替换 ?. 为 && 判空 + 兜底】 -->
              <el-menu-item index="/CityIndex" v-if="userInfo && userInfo.username !=='jkq_2026'">{{(userInfo && userInfo.district) || ''}}全景分析</el-menu-item>
              <el-menu-item index="/CityIndex" v-if="userInfo && userInfo.username ==='jkq_2026'">九江市经开区全景分析</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main style="background: #E6E7EB;">
          <router-view v-on:public_header="public_header" :parent_value="timeChoose"  ref="mychild"
                       style="padding-bottom: 20px;padding-top:20px;min-height: 100%"/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄',
        clientHeight:'',
        lastTime: null, // 最后一次点击的时间
        currentTime: null, // 当前点击的时间
        timeOut: 3 * 60 * 60 * 1000, // 设置超时时间:3个小时
      };
      return {
        isShow:false,
        userInfo: {username: '', password: ''}, // 初始化为空对象，避免null
        header_show: false,
        active_path: '/index',
        timeChoose: '',
        tableData: Array(20).fill(item),
        open_list:['1'],
        // 定义县域账号列表
        countyUserList: [
          'wnx_2025',
          'xsx_2025',
          'yyx_2025',
          'dax_2025',
          'dcx_2025',
          'hkx_2025',
          'pzx_2025',
          'rcs_2025',
          'gqcs_2025',
          'lss_2025',
          'csq_2025',
          'xyq_2025',
          'jkq_2026',
          'lxq_2025'
        ]
      }
    },
    created () {
      // 【★ 兼容写法：读取sessionStorage并兜底，避免null】
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
      this.oneMonth()
      this.lastTime = new Date().getTime()
    },
    mounted () {
      this.active_path = this.$route.path
      this.clientHeight =   `${document.documentElement.clientHeight}`
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`;
      };
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      }
    },
    beforeUpdate: function () {
      // 【★ 核心修复：读取sessionStorage并兜底，避免null】
      const storageUserInfo = sessionStorage.getItem('userInfo');
      this.userInfo = storageUserInfo ? JSON.parse(storageUserInfo) : {};

      // 【★ 兼容写法：所有判断加 userInfo && 前缀，移除 ?.】
      if(this.userInfo && this.userInfo.username == 'wnx_2025'){
        this.userInfo.district = '武宁县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'xsx_2025'){
        this.userInfo.district = '修水县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'yyx_2025'){
        this.userInfo.district = '永修县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'dax_2025'){
        this.userInfo.district = '德安县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'dcx_2025'){
        this.userInfo.district = '都昌县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'hkx_2025'){
        this.userInfo.district = '湖口县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'pzx_2025'){
        this.userInfo.district = '彭泽县'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'rcs_2025'){
        this.userInfo.district = '瑞昌市'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'gqcs_2025'){
        this.userInfo.district = '共青城市'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'lss_2025'){
        this.userInfo.district = '庐山市'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'csq_2025'){
        this.userInfo.district = '柴桑区'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'xyq_2025'){
        this.userInfo.district = '浔阳区'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'jkq_2026'){
        this.userInfo.district = '九江经济技术开发区'
        this.isShow = false
      }else if (this.userInfo && this.userInfo.username == 'lxq_2025'){
        this.userInfo.district = '濂溪区'
        this.isShow = false
      }
      else {
        this.isShow = true
      }
      if (this.$route.path == '/') {
        this.active_path = '/index'
      } else {
        this.active_path = this.$route.path
      }
    },
    methods: {
      isTimeOut () {
        this.currentTime = new Date().getTime() // 记录这次点击的时间
        if (this.currentTime - this.lastTime > this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于3个小时
          if (sessionStorage.getItem('userInfo')) { // 如果是登录状态
            this.userOut()
            // 【★ 兼容写法：加 && 判空，避免 $message 未定义报错】
            if(this.$message) this.$message('登录超时，请重新登录');
          }
          else {
            this.lastTime = new Date().getTime()
          }
        } else {
          this.lastTime = new Date().getTime() // 如果在3小时内点击，则更新最后点击时间
        }
      },
      changeFixed(clientHeight){ //动态修改样式
        console.log(clientHeight);
      },
      //是否显示头部
      public_header: function (bool) {
        this.header_show = bool
        this.isTimeOut ()
      },
      chooseTime(){
        console.dir(this.active_path)
        if(this.active_path == '/countrysideIndex'){
          this.$refs.mychild.getCountrysideList(this.timeChoose);
        }else if(this.active_path == '/index'){
          this.$refs.mychild.getHomeList(this.timeChoose);
        }else if(this.active_path == '/b2bRetailers'){
          this.$refs.mychild.getB2bWholeList(this.timeChoose);
        }
      },
      //选择近1个月
      oneMonth (val) {
        var dataArr = []
        var data = new Date()
        var year = data.getFullYear()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.timeChoose = dataArr[1]
      },
      // 【★ 核心修复：退出登录方法（Vue2兼容版）】
      userOut() {
        try {
          // 1. 安全清空 sessionStorage
          if (window.sessionStorage) {
            window.sessionStorage.clear();
          }

          // 2. 重置用户信息为空对象（关键！避免null）
          this.userInfo = {};
          this.token = '';
          this.isLogin = false;

          // 3. 路由跳转（Vue2兼容写法，移除.catch，改用回调）
          this.$router.push('/',
            // 跳转成功回调
            () => {
            // console.log('成功退出');
            },
            // 跳转失败兜底
            (err) => {
              console.warn('路由跳转失败，兜底跳转:', err);
              window.location.href = window.location.origin + '/#/login';
            }
          );
        } catch (err) {
          // 捕获所有意外报错
          console.error('退出登录执行异常:', err);
        }
      }
    }
  }
</script>

<style>
  * {
    margin: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
  }

  body {
    /*padding-bottom: 150px;*/
    /*background-color: #171C30;*/
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    /*margin-top: 60px;*/
    height: 100%;
  }

  #app .el-menu-item.is-active {
    background-color:rgba(255,255,255,0.53) !important;;
  }
  .el-main{
    padding: 0 !important;
  }
  .el-menu {
    border-right: none !important;
  }
  .el-header{
    padding: 0 !important;
    height: 55px !important;
    background-color: #10366B !important;
    font-family: SimSun;
    color: white;
    font-weight: 400;
  }

  .el-submenu .el-menu-item {
    min-width: 100px;
    padding-left: 53px !important;
  }

  .el-submenu.is-active .el-submenu__title {
    color: white !important;
  }

  .el-submenu.is-active .el-submenu__title i {
    color: white;
  }
  .el-submenu [class^=el-icon-]{
    color: white;
  }

  .footer {
    height: 100px !important;
    text-align: center;
    background-color: #8B94D6;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: white;
    padding-top: 30px;
    clear: both;
  }

  .el-table td, .el-table th.is-leaf {
    border-bottom: none !important;
  }

  ::-webkit-scrollbar{
    width: 12px;
  }
  /*滚动槽*/
  ::-webkit-scrollbar-track{
    /*-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3) ;*/
    /*border-radius: 10px;*/
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    background: rgba(102,102,102,0.2) !important;;
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(102,102,102,0.2) !important;;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(102,102,102,1) !important;;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue